export const OVERTIME_THRESHOLD_HOURS_PER_WEEK = 40
export const OVERTIME_MULTIPLIER = 1.5

export type PaidPerson = {
  payType: 'Hourly' | 'Salary'
  hourlyRate: number | null
  hoursPerWeek: number | null
  annualSalary: number | null
}

export const calculateHoursWorkedPerYear = (hoursPerWeek: number, workingWeeks: number): number => {
  return hoursPerWeek * workingWeeks
}

export const overtimeHoursPerYear = (hoursPerWeek: number, workingWeeks: number): number => {
  return Math.max(0, hoursPerWeek - OVERTIME_THRESHOLD_HOURS_PER_WEEK) * workingWeeks
}

export const fieldEmployeeAnnualCost = (person: PaidPerson, workingWeeks: number): number => {
  if (person.payType === 'Salary') {
    return person.annualSalary || 0
  }
  const hourlyWage = person.hourlyRate || 0
  const hoursPerWeek = person.hoursPerWeek || 0
  const hoursWorked = calculateHoursWorkedPerYear(hoursPerWeek, workingWeeks)
  const overtimeHours = overtimeHoursPerYear(hoursPerWeek, workingWeeks)
  const regularHours = hoursWorked - overtimeHours
  return regularHours * hourlyWage + overtimeHours * hourlyWage * OVERTIME_MULTIPLIER
}

export const adminEmployeeAnnualCost = (person: PaidPerson, workingWeeks: number): number => {
  if (person.payType === 'Salary') {
    return person.annualSalary || 0
  }
  const hoursWorked = calculateHoursWorkedPerYear(person.hoursPerWeek || 0, workingWeeks)
  return (person.hourlyRate || 0) * hoursWorked
}

export const sumFieldEmployeeCost = (people: PaidPerson[], workingWeeks: number): number => {
  return people.reduce((total, person) => total + fieldEmployeeAnnualCost(person, workingWeeks), 0)
}

export const sumAdminEmployeeCost = (people: PaidPerson[], workingWeeks: number): number => {
  return people.reduce((total, person) => total + adminEmployeeAnnualCost(person, workingWeeks), 0)
}
